import { Image } from '@/components/Image';
import { AcademyConnectionWorkspaceDetailsFragment } from '@/modules/lyearn-connect/graphql/fragments/generated/AcademyConnectionWorkspaceDetails';
import { getWorkspaceIcon } from '@/modules/lyearn-connect/utils';

export const getAcademyFilterOption = (
  workspaceDetail: AcademyConnectionWorkspaceDetailsFragment,
) => ({
  value: workspaceDetail.workspaceId,
  label: workspaceDetail.workspaceName,
  Icon: () => (
    <Image
      alt={workspaceDetail.workspaceName}
      className="h-22 w-22"
      height={22}
      objectFit="contain"
      src={getWorkspaceIcon(workspaceDetail)}
      width={22}
    />
  ),
});
